import apiClient from './client'

export interface CommInterfaceType {
  id: number
  code: string
  name: string
  category: string
  description?: string
  detail_kind: 'lan' | 'modbus' | 'audio' | 'generic'
  allowed_directions: string // e.g. "in,out,bidirectional"
  sort_order: number
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export const getCommInterfaceTypes = async (): Promise<CommInterfaceType[]> => {
  const response = await apiClient.get('/api/comm_interface_types')
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to fetch interface types')
}

export const getCommInterfaceType = async (id: number): Promise<CommInterfaceType> => {
  const response = await apiClient.get(`/api/comm_interface_types/${id}`)
  if (response?.data && typeof response.data === 'object' && 'id' in response.data) {
    return response.data as CommInterfaceType
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Interface type not found')
}

export const createCommInterfaceType = async (
  data: Omit<CommInterfaceType, 'id' | 'created_at' | 'updated_at'>
): Promise<CommInterfaceType> => {
  const response = await apiClient.post('/api/comm_interface_types', data)
  if (response?.data && typeof response.data === 'object' && 'id' in response.data) {
    return {
      ...data,
      id: parseInt(response.data.id as string),
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    } as CommInterfaceType
  }
  if (response?.data && response.data.success) {
    return {
      ...data,
      id: parseInt(response.data.data.id as string),
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    } as CommInterfaceType
  }
  throw new Error('Failed to create interface type')
}

export const updateCommInterfaceType = async (
  id: number,
  data: Partial<CommInterfaceType>
): Promise<void> => {
  await apiClient.put(`/api/comm_interface_types/${id}`, data)
}

export const deleteCommInterfaceType = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/comm_interface_types/${id}`)
}
